// extracted by mini-css-extract-plugin
module.exports = {"container":"WemapReact_container__j6kWE"};